import axios from 'axios';
import { generateImpersonationQRURL } from '@app/constants/ApiEndPoints';

export const generateImpersonationQR = async (parent_id: number) => {
    try {
        const response = await axios.post(generateImpersonationQRURL, { parent_id });
        if (response.status === 200) return response.data;
    } catch (error) {
        return error?.response?.data;
    }
};
